import {ReactNode} from 'react';
import {Loading} from '../../../../design-system/atoms/Loading/Loading';
import {useInfiniteContentHomeNoticeQuery} from '../../../../wrapper/contentWrapper';

export interface ContentHomeNoticeMobileFetcherHeadlessProps {
  seriesId: number;
  children?: ReactNode;
}

/**
 * 콘텐츠홈 소식
 */
export function ContentHomeNoticeMobileFetcherHeadless({
  seriesId,
  children,
}: ContentHomeNoticeMobileFetcherHeadlessProps) {
  const {isLoading, data} = useInfiniteContentHomeNoticeQuery(
    {
      contentHomeNoticeInput: {seriesId, page: 0},
    },
    {
      initialPageParam: {
        contentHomeNoticeInput: {seriesId, page: 0},
      },
      getNextPageParam: () => undefined,
    }
  );

  if (!children) {
    return null;
  }
  return (
    <>
      {isLoading && (
        <div className="flex-center-full">
          <Loading />
        </div>
      )}
      {!isLoading && !!data && children}
    </>
  );
}
